module.exports = __webpack_public_path__ + "img/021-flag.3c4136cd.svg";